import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import Count from "../../components/user/admin/Count";
import AdminEvents from "../../components/user/admin/AdminEvents";
import { useEventContext } from "../../context/EventContext";
import { fetchEventData } from "../../api/EventApi";
import { dynamicFailed } from "../../hooks/useToast";
import { fetchMemberLists } from "../../api/MemberApi";
import { IMemberListData } from "../../exports/interfaces";
import { useUserDataContext } from "../../context/UserDataContext";
import { checkUser } from "../../api/UserApi";
import { openLogin } from "../../exports/exports";

const AdminDashboard = () => {
  const { setLoading } = useLoader();
  const { eventData, setEventData } = useEventContext();
  const [memberCount, setMemberCount] = useState<number>(0);
  const [countryCount, setCountryCount] = useState<number>(0);
  const { userData, setUserData } = useUserDataContext();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          userData?.data?.roles[0]?.name !== "sa" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);

  useEffect(() => {
    setLoading(true);
    if (eventData.length === 0) {
      Promise.all([fetchEventData()])
        .then(([eventData]) => {
          setEventData(eventData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          dynamicFailed("Server Error");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  }, [eventData.length, setEventData, setLoading]);

  useEffect(() => {
    Promise.all([fetchMemberLists()])
      .then(([listMemberData]) => {
        const activeMembers = listMemberData.filter(
          (member: IMemberListData) => member.attributes?.Status === "Activate"
        );

        setMemberCount(activeMembers.length);

        const countries = activeMembers.map((member: IMemberListData) =>
          member.attributes?.Country?.trim()
        );
        const uniqueCountries = new Set(countries.filter(Boolean));
        setCountryCount(uniqueCountries.size);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);

  return (
    <>
      <Count
        Title={"Dashboard"}
        memberCount={memberCount}
        countryCount={countryCount}
      />
      <AdminEvents />
    </>
  );
};

export default AdminDashboard;
